// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatMemberTimeoutClearBody = {
  chatId: string;
  userId: string;
};

export type typeChatMemberTimeoutClearOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { userId: string; isCleared: boolean };
};

export type typeChatMemberTimeoutClearOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatMemberTimeoutClearOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatMemberTimeoutClearOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatMemberTimeoutClearBody = {
  type: "object",
  properties: {
    chatId: { type: "string", maxLength: 3000, minLength: 1 },
    userId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["chatId", "userId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatMemberTimeoutClear(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatMemberTimeoutClearBody);
  }

  return async function postChatMemberTimeoutClear(
    payload: typeChatMemberTimeoutClearBody,
  ): Promise<
    typeChatMemberTimeoutClearOutput200 | typeChatMemberTimeoutClearOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatMemberTimeoutClear" failed before calling the network. #75ed1537337f`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#75ed1537337f" },
        },
        data: null,
      } as typeChatMemberTimeoutClearOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/member-timeout-clear`,
      httpMethod: "POST",
      options,
    })) as
      typeChatMemberTimeoutClearOutput200 | typeChatMemberTimeoutClearOutput400;
  };
}
